// extracted by mini-css-extract-plugin
export default {"section-header":"Home_section-header__jxY-y"};